<template>
  <div
    class="notification"
    :class="{
      'notification--alert': notificationType === 'alert',
      'notification--warning': notificationType === 'warning'
    }"
  >
    <a-icon
      type="warning"
      class="notification__icon"
    />
    {{ notificationText }}
    <a-button
      v-if="notificationButton === 'topUp'"
      class="notification__button"
      ghost
      type="text"
      size="small"
      @click="topUpModalIsVisible = true"
    >
      {{ $t("dashboard.billing.top_up") }}
    </a-button>

    <BillingTopUp
      :visible="topUpModalIsVisible"
      @close="topUpModalIsVisible = false"
    />
  </div>
</template>

<script lang="ts" setup>
import { defineProps, ref } from "vue"

import BillingTopUp from "@/components/Common/BillingTopUp"

type Props = {
  notificationType: "warning" | "alert"
  notificationText: string
  notificationButton: string
}

const { notificationType, notificationText, notificationButton } = withDefaults(
  defineProps<Props>(),
  {
    notificationButton: "hidden"
  }
)

const topUpModalIsVisible = ref<boolean>(false)
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: $dashboard-alert-height;
  height: $dashboard-alert-height;
  color: white;
  font-weight: $font-weight-bold;
  &--alert {
    background-color: $dashboard-alert-background-color;
  }
  &--warning {
    background-color: $dashboard-warning-background-color;
  }
  &__icon {
    font-size: 18px;
    margin-right: 8px;
  }
  &__button {
    margin-left: 16px;
    &:hover,
    &:active,
    &:focus {
      color: #fff !important;
      border-color: #fff !important;
    }
  }
}
</style>
